import {config as accountsConfig} from './Accounts';
import {config as pspindexConfig} from './PSPIndexes';
import {config as notApplicableConfig} from './NotApplicable';

export default (labels, action) => [
	accountsConfig(labels),
	pspindexConfig(labels),
	notApplicableConfig(labels, action)
];
